import {BaseObject} from './BaseObject';
import {Document} from './Document';

export class DocumentLiquidation extends BaseObject {
    id: number;
    amount: number;
    document: Document;
    documents: Document[];
    entryDate: any;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/DocumentLiquidation.ts